<div class="profile-page">
  <div class="page-header">
    <h1>Thông tin cá nhân</h1>
    <p class="page-desc">Cập nhật email cá nhân và số điện thoại liên hệ của bạn.</p>
  </div>

  <nz-spin [nzSpinning]="isLoading">
    <div class="profile-card">
      <div class="profile-meta" *ngIf="fullName || contactEmail">
        <div class="profile-meta__item" *ngIf="fullName">
          <span class="profile-meta__label">Họ và tên</span>
          <span class="profile-meta__value">{{ fullName }}</span>
        </div>
        <div class="profile-meta__item" *ngIf="contactEmail">
          <span class="profile-meta__label">Email hệ thống</span>
          <span class="profile-meta__value">{{ contactEmail }}</span>
        </div>
      </div>

      <form [formGroup]="form" class="profile-form" (ngSubmit)="submitUpdate()">
        <div class="profile-field">
          <hbt-input-text
            class="profile-input"
            [defaultInput]="true"
            labelText="Email cá nhân (thường sử dụng) <span class='label__required'>*</span>"
            placeholderText="Nhập email cá nhân"
            formControlName="personalEmail"
            [required]="true"
            [type]="isSubmitted && f['personalEmail'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['personalEmail'].errors !== null"
            [errors]="f['personalEmail'].errors"
            [errorDefs]="[
              { errorName: 'required', errorDescription: 'Bắt buộc nhập email cá nhân' },
              { errorName: 'email', errorDescription: 'Email không hợp lệ' }
            ]">
          </hbt-input-text>
        </div>

        <div class="profile-field">
          <hbt-input-text
            class="profile-input"
            [defaultInput]="true"
            labelText="Số điện thoại <span class='label__required'>*</span>"
            placeholderText="Nhập số điện thoại"
            formControlName="mobileNumber"
            [required]="true"
            [type]="isSubmitted && f['mobileNumber'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['mobileNumber'].errors !== null"
            [errors]="f['mobileNumber'].errors"
            [errorDefs]="[
              { errorName: 'required', errorDescription: 'Bắt buộc nhập số điện thoại' },
              { errorName: 'pattern', errorDescription: 'Số điện thoại không hợp lệ' }
            ]">
          </hbt-input-text>
        </div>

        <div class="otp-row" *ngIf="needOtp">
          <button type="button" class="otp-btn" nz-button [disabled]="isLoading" (click)="sendOtp()">
            {{ otpSent ? 'Gửi lại OTP' : 'Gửi OTP' }}
          </button>
          <span class="otp-hint" *ngIf="otpSent">Đã gửi tới {{ maskedOtpEmail }} ({{ otpDuration }}s)</span>
          <span class="otp-hint otp-hint--warn" *ngIf="!otpSent">
            Cần xác minh email mới bằng OTP trước khi lưu.
          </span>
        </div>

        <div class="profile-field" *ngIf="needOtp && otpSent">
          <hbt-input-text
            class="profile-input"
            [defaultInput]="true"
            labelText="Mã OTP <span class='label__required'>*</span>"
            placeholderText="Nhập mã 6 số"
            formControlName="otpCode"
            [type]="isSubmitted && f['otpCode'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['otpCode'].errors !== null"
            [errors]="f['otpCode'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập mã OTP khi đổi email cá nhân' }]">
          </hbt-input-text>
        </div>

        <div class="profile-actions">
          <button
            type="submit"
            class="profile-save-btn"
            nz-button
            nzType="primary"
            [disabled]="!canSave"
            [attr.title]="saveHint || null">
            Lưu thay đổi
          </button>
          <p class="save-hint" *ngIf="saveHint">{{ saveHint }}</p>
        </div>
      </form>
    </div>
  </nz-spin>
</div>
